import React, { useState, useMemo, memo } from "react";
import styles from "./violazioneMaxPerditaMaxGuadagnoCompare.module.scss";
import { useTranslation } from "react-i18next";
import colorsStore from "shared/store/colorsStore";

type ViolazioneMaxPerditaMaxGuadagnoCompareProps = {
  data: any;
  data2: any;
  title: string;
};

const ViolazioneMaxPerditaMaxGuadagnoCompareComponent: React.FC<
  ViolazioneMaxPerditaMaxGuadagnoCompareProps
> = ({ data, data2, title = "" }) => {
  const { t } = useTranslation();
  //   const dataTable =
  // data.analisi_backtest.rendimenti_cumulati_portafoglio_per_holding_period;

  const dataMaxPerdita =
    data.analisi_backtest.distribuzione_rendimenti_mensili_violazioni
      .max_perdita;

  const dataMaxGuadagno =
    data.analisi_backtest.distribuzione_rendimenti_mensili_violazioni
      .max_guadagno;

  const dataMaxPerdita2 =
    data2.analisi_backtest.distribuzione_rendimenti_mensili_violazioni
      .max_perdita;

  const dataMaxGuadagno2 =
    data2.analisi_backtest.distribuzione_rendimenti_mensili_violazioni
      .max_guadagno;

  const [columns, setColumns] = useState(6);
  const totalRows = 3;
  const rows = [];

  for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
    const row = rowIndex + 1;

    rows.push(row);
  }
  const cells = useMemo(() => {
    const generatedCells = [];
    for (const row of rows) {
      for (let colIndex = 0; colIndex < columns; colIndex++) {
        const cell = {
          row,
          col: colIndex + 1,
        };

        generatedCells.push(cell);
      }
    }

    return generatedCells;
  }, [rows, columns]);

  const getRenderedCells = (
    cells: { row: number; col: number }[],
    data: { label: string; weight: number }[],
    data2: { label: string; weight: number }[],
    totalRows: number,
    styles: any,
  ) => {
    return cells.map((cell) => {
      const { row, col } = cell;

      if (row === 1) {
        return (
          <div
            key={`${row}-${col}`}
            className={[styles.cellViolazione, styles.productName].join(" ")}
          >
            {col > 1 && data[col - 2].label}
          </div>
        );
      }
      if (row === 2 && col === 1) {
        return (
          <div
            key={`${row}-${col}`}
            className={[styles.cellKeys, styles.cellWithNoBorder].join(" ")}
            style={{ paddingBottom: 15 }}
          >
            {col === 1 && t("portafoglioCompare.portafoglio1")}
          </div>
        );
      }
      if (row === 3 && col === 1) {
        return (
          <div
            key={`${row}-${col}`}
            className={[styles.cellKeys, styles.cellWithNoBorder].join(" ")}
            style={{ paddingBottom: 15 }}
          >
            {col === 1 && t("portafoglioCompare.portafoglio2")}
          </div>
        );
      }
      if (row === 2) {
        return (
          <div
            key={`${row}-${col}`}
            className={[
              styles.cellKeysViolazione,
              styles.cellWithNoBorder,
            ].join(" ")}
            style={{ paddingBottom: 15 }}
          >
            {col > 1 && data[col - 2].weight.toFixed(2)}
          </div>
        );
      }
      if (row === 3) {
        return (
          <div
            key={`${row}-${col}`}
            className={[
              styles.cellKeysViolazione,
              styles.cellWithNoBorder,
            ].join(" ")}
            style={{ paddingBottom: 15 }}
          >
            {col > 1 && data2[col - 2].weight.toFixed(2)}
          </div>
        );
      }

      return (
        <div key={`${row}-${col}`} className={styles.cellValue}>
          -
        </div>
      );
    });
  };

  const renderedCellsMaxPerdita = useMemo(() => {
    return getRenderedCells(
      cells,
      dataMaxPerdita,
      dataMaxPerdita2,
      totalRows,
      styles,
    );
  }, [cells, dataMaxPerdita, totalRows, styles]);

  const renderedCellsMaxGuadagno = useMemo(() => {
    return getRenderedCells(
      cells,
      dataMaxGuadagno,
      dataMaxGuadagno2,
      totalRows,
      styles,
    );
  }, [cells, dataMaxPerdita, totalRows, styles]);

  return (
    <div>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.container}>
        <div className={`${styles.grid} ${styles[`grid${columns}`]}`}>
          {renderedCellsMaxPerdita}
        </div>
      </div>
      <div className={styles.container} style={{ marginTop: 16 }}>
        <div className={`${styles.grid} ${styles[`grid${columns}`]}`}>
          {renderedCellsMaxGuadagno}
        </div>
      </div>
    </div>
  );
};

export const ViolazioneMaxPerditaMaxGuadagnoCompare = memo(
  ViolazioneMaxPerditaMaxGuadagnoCompareComponent,
  (prevProps, nextProps) => {
    return JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  },
);

export default ViolazioneMaxPerditaMaxGuadagnoCompare;
